import { DEFAULT_SLIDES_SECTIONS } from 'partner360/features/QBR/configs'
import { ISlideSection } from 'partner360/models/qbr/ISlideSection'

export const getExportSlides = (
  storedSections: ISlideSection[],
  updatedSections?: ISlideSection[]
): ISlideSection[] => {
  return DEFAULT_SLIDES_SECTIONS.map((defaultSection) => {
    let section = defaultSection

    let foundSection = updatedSections?.find((el) => el.Key === defaultSection.Key)
    if (!foundSection) {
      foundSection = storedSections?.find((el) => el.Key === defaultSection.Key)
    }
    if (foundSection) {
      section = foundSection
    }

    return section
  })
}
